import React, { useState, useEffect, useContext, useRef } from "react";
import api from "../../api/axiosConfig";
import { toast } from "react-toastify";
import { useRolePermissions } from "../Settings/RoleContext";
import { MultiSelect } from "react-multi-select-component";
import DatePicker from "react-datepicker";
import { useAuth } from "../Authentication/AuthContext";
const AddTodo = ({ setTodoDialOpen }) => {
  const { hasPermission } = useRolePermissions();
  const { userDetails } = useAuth();
  const [todoDueDate, setTodoDueDate] = useState(null);
  const [tsCategory, setTsCategory] = useState("Project");
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [phases, setPhases] = useState([]);
  const [selectedPhase, setSelectedPhase] = useState([]);
  const [users, setUsers] = useState([]);
  const [projectManager, setProjectManager] = useState([]);
  const [estimates, setEstimates] = useState([]);
  const [selectedEstimate, setSelectedEstimate] = useState("");
  const [projectUsers, setProjectUsers] = useState([]);
  const [isOverallAssigned, setIsOverallAssigned] = useState(false);
  const [isOverallCC, setIsOverallCC] = useState(false);
  const [projectCustomers, setProjectCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [assignedTo, setAssignedTo] = useState([]);
  const [reportedTo, setReportedTo] = useState([]);
  const [ccTo, setCCTo] = useState([]);
  const [comments, setComments] = useState("");
  const [notification, setNotification] = useState(1);
  const [subject, setSubject] = useState("");
  const [priority, setPriority] = useState("Low");
  const dropdownRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProjectName, setSelectedProjectName] = useState("");
  const [selectedProjectCustomer, setSelectedProjectCustomer] = useState("");
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (selectedEstimate) {
      const selectedEstimateCustomer = estimates.find(
        (e) => e.id === Number(selectedEstimate)
      );
      setProjectCustomers([
        {
          contact_name: selectedEstimateCustomer.contact_name,
          contact_id: selectedEstimateCustomer.contact_id,
        },
      ]);
    }
  }, [selectedEstimate]);

  useEffect(() => {
    if (selectedProject) {
      const project = projects.find((p) => p.id === Number(selectedProject));
      setSelectedProjectName(`${project.projectno}-${project.name}`);
      setSelectedProjectCustomer(project.customer_id);
    }
  }, [selectedProject, projects]);

  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      try {
        const res = await api.get(`/api/projectlistdata`);
        const userRes = await api.get("/api/users");
        const activeProjects = res.data.filter(
          (project) => project.activestatus === 1
        );
        const estimateRes = await api.get(`/api/estimates-timesheet`);
        setEstimates(estimateRes.data);
        setUsers(userRes.data);
        setProjectManager(
          userRes.data.filter((u) => u.role_name === "Project_Manager")
        );
        setProjects(activeProjects);
      } catch (error) {
        setError(error);
        console.error("Error fetching project data:", error.message || error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
    // Fetch To-Do list when component mounts
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!selectedProject || !selectedProjectCustomer) return;

      setError(null);

      try {
        const [userRes, customerRes, phaseRes] = await Promise.all([
          api.get(`/api/projects/${selectedProject}/users`),
          api.get(`/api/customers/${selectedProjectCustomer}/contacts`),
          api.get(`/api/project/${selectedProject}/phases`),
        ]);
        setPhases(phaseRes.data || []);
        setProjectUsers(userRes.data || []);
        setProjectCustomers(customerRes.data.contacts || []);
      } catch (error) {
        setError(error);
        console.error("Error fetching data:", error.message || error);
      }
    };

    fetchData();
  }, [selectedProject, selectedProjectCustomer]);

  const getOptions = (isOverall) => {
    let userList = [];

    if (tsCategory === "Project") {
      userList = isOverall ? users : projectUsers;
    } else if (tsCategory === "General") {
      userList = users;
    } else if (tsCategory === "Estimate") {
      userList = isOverall ? users : projectManager;
    }

    const baseOptions = (userList || [])
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((user) => ({
        label: user.name || "Unnamed",
        value: String(user.id),
      }));

    const overallOption =
      tsCategory === "Project" || tsCategory === "Estimate"
        ? [{ label: "Overall Users", value: "overall-users" }]
        : [];

    return [...baseOptions, ...overallOption];
  };

  const handlePriorityChange = (event) => {
    setPriority(event.target.value);
  };
  const tabCount = hasPermission("estimates", "create") ? 3 : 2;
  const sliderLeft = () => {
    if (tsCategory === "Project") return "0%";
    if (tsCategory === "General") return tabCount === 3 ? "33.33%" : "50%";
    return tabCount === 3 ? "66.66%" : "100%";
  };

  const sliderWidth = () => 100 / tabCount + "%";
  const changeTsCategory = (c) => {
    setTsCategory(c);
    setSelectedEstimate("");
    setAssignedTo([]);
    setCCTo([]);
    setReportedTo([]);
    setComments("");
    setSelectedProject("");
    setSelectedProjectName("");
    setTodoDueDate("");
    setIsOverallAssigned(false);
    setIsOverallCC(false);
    setSubject("");
  };
  const handleSearchChange = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(e.target.value);
    setSelectedProjectName("");

    const filtered = projects.filter((project) => {
      const name = project.name || ""; // Fallback to an empty string
      const projectno = project.projectno || ""; // Fallback to an empty string
      const displayName = project.displayName || ""; // Fallback to an empty string

      return (
        name.toLowerCase().includes(searchValue) ||
        projectno.toLowerCase().includes(searchValue) ||
        displayName.toLowerCase().includes(searchValue)
      );
    });

    setFilteredProjects(filtered);
    setShowDropdown(true); // Show the dropdown when the user types
  };
  const handleFocus = () => {
    setSearchTerm(""); // Reset the search term to show all projects
    setFilteredProjects(projects); // Show all projects when focusing on the input
    setShowDropdown(true); // Show the dropdown
  };

  const handleClickOutside = (event) => {
    // Check if the click is outside the dropdown and profile
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) //&&
      // profileRef.current &&  !profileRef.current.contains(event.target)
    ) {
      setShowDropdown(false); // Close the dropdown
    }
  };

  // Add event listener for clicks outside the component
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle Project Selection
  const handleProjectChange = (e) => {
    setSearchTerm("");
    setShowDropdown(false);
    setIsOverallAssigned(false);
    setIsOverallCC(false);
    setAssignedTo([]);
    setCCTo([]);
    setReportedTo([]);
    setSelectedProject(e.target.value); // Sets selected project
  };

  // Add New To-Do List
  const handleAddToDoList = async () => {
    const newToDo = {
      project: selectedProject,
      phase: Number(selectedPhase),
      date: new Date(),
      duedate: todoDueDate,
      subject,
      priority,
      comments,
      notification,
      assignedTo,
      reportedTo,
      ccTo,
      created_by: userDetails.id,
      selectedEstimate,
      tsCategory,
    };
    const showError = () => {
      toast.error("Fill required fields", {
        position: "bottom-center",
        autoClose: 2000,
      });
    };

    const isEmpty = (value) =>
      !value || (Array.isArray(value) && value.length === 0);

    let missingFields = false;

    if (tsCategory === "Project") {
      missingFields =
        isEmpty(selectedProject) ||
        isEmpty(selectedPhase) ||
        isEmpty(assignedTo) ||
        isEmpty(ccTo) ||
        isEmpty(reportedTo) ||
        isEmpty(subject) ||
        isEmpty(comments);
    } else if (tsCategory === "Estimate") {
      missingFields =
        isEmpty(selectedEstimate) ||
        isEmpty(assignedTo) ||
        isEmpty(ccTo) ||
        isEmpty(reportedTo) ||
        isEmpty(subject) ||
        isEmpty(comments);
    } else {
      missingFields =
        isEmpty(assignedTo) ||
        isEmpty(ccTo) ||
        isEmpty(reportedTo) ||
        isEmpty(subject) ||
        isEmpty(comments);
    }

    if (missingFields) {
      showError();
      return;
    }

    try {
      await api.post("/api/todolists", newToDo);
      alert("To-Do List created successfully!");
      setComments("");
      setAssignedTo([]);
      setReportedTo([]);
      setPriority("Low");
      setTodoDueDate(null);
      setSelectedProject("");
      setSelectedProjectName("");
      setSubject("");
      setCCTo([]);
      setSelectedPhase([]);
      setTodoDialOpen(false);
    } catch (error) {
      console.error("Error adding to-do list:", error);
      alert("Failed to create to-do list.");
    }
  };

  return (
    <div className="add-todo-overlay-dial">
      <div className="add-todo-con">
        <div className="add-new-todo-header">
          <h3
            style={{
              backgroundColor: "transparent",
              marginLeft: "19px",
              marginTop: "5px",
              fontSize: "15px",
            }}
          >
            Add To do
          </h3>
        </div>
        <div className="add-timesheet-category-con">
          <div
            className="tab-slider-ts"
            style={{
              left: sliderLeft(),
              width: sliderWidth(),
            }}
          />
          <button
            onClick={() => {
              changeTsCategory("Project");
            }}
            className={
              tsCategory === "Project"
                ? "dial-active-btn active-tab-btn"
                : "dial-normal-btn normal-tab-btn"
            }
          >
            Project
          </button>
          <button
            onClick={() => {
              changeTsCategory("General");
            }}
            className={
              tsCategory === "General"
                ? "dial-active-btn active-tab-btn"
                : "dial-normal-btn normal-tab-btn"
            }
          >
            General
          </button>
          {hasPermission("estimates", "create") && (
            <button
              onClick={() => {
                changeTsCategory("Estimate");
              }}
              className={
                tsCategory === "Estimate"
                  ? "dial-active-btn active-tab-btn"
                  : "dial-normal-btn normal-tab-btn"
              }
            >
              Estimate
            </button>
          )}
        </div>
        <div className="todo-content-container">
          {tsCategory === "Project" && (
            <>
              <h3 className="todo-name">Project</h3>
              <input
                ref={dropdownRef}
                className="todo-d-input"
                placeholder="Search Projects"
                value={searchTerm || selectedProjectName || ""}
                onChange={handleSearchChange}
                onFocus={handleFocus}
                onMouseDown={() => handleClickOutside}
              />
            </>
          )}
          {showDropdown &&
            tsCategory === "Project" &&
            (showDropdown && filteredProjects?.length > 0 ? (
              <ul
                style={{ zIndex: "50" }}
                ref={dropdownRef}
                className="todo-display-box"
              >
                {filteredProjects.map((project) => (
                  <li
                    key={project.id}
                    value={project.id}
                    onClick={(e) => handleProjectChange(e)}
                    onMouseDown={() => handleClickOutside}
                    className="project-dropdown-item"
                  >
                    {project.projectno}-{project.name}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No Projects available, Contact DC to add project for you.</p>
            ))}
          {selectedProject &&
            tsCategory === "Project" &&
            phases.phases?.length > 0 && (
              <>
                <h3 className="todo-name">Phase</h3>
                <select
                  className="select-todo-proj"
                  value={selectedPhase}
                  onChange={(e) => setSelectedPhase(e.target.value)}
                >
                  <option value="">Select Phase</option>
                  {phases.phases.map((phase) => (
                    <option key={phase.id} value={phase.id}>
                      {phase.phaseno}-{phase.title}
                    </option>
                  ))}
                </select>
              </>
            )}
          {tsCategory === "Estimate" && (
            <>
              <h3 className="user-name">Estimate</h3>
              <select
                onChange={(e) => {
                  setSelectedEstimate(e.target.value);
                  setProjectCustomers([]);
                  setReportedTo([]);
                }}
                value={selectedEstimate || ""}
                className="timesheet-input"
              >
                <option value="" disabled>
                  --Select Estimate--
                </option>
                {estimates.length > 0 ? (
                  estimates.map((est) => (
                    <option key={est.id} value={est.id}>
                      {`${est.estimationno}-${est.projectname}`}
                    </option>
                  ))
                ) : (
                  <option value="" disabled>
                    There are no estimates available.
                  </option>
                )}
              </select>
            </>
          )}
          <h3 className="todo-name">Assigned to</h3>
          <MultiSelect
            className="todo-dropdown"
            options={getOptions(isOverallAssigned)}
            value={assignedTo
              .map((id) => {
                const source =
                  isOverallAssigned || tsCategory === "General"
                    ? users
                    : tsCategory === "Project"
                    ? projectUsers
                    : projectManager || [];
                const user = source.find((u) => String(u.id) === String(id));
                return user
                  ? { label: user.name, value: String(user.id) }
                  : null;
              })
              .filter(Boolean)}
            onChange={(selected) => {
              const includesOverall = selected.some(
                (item) => item.value === "overall-users"
              );

              if (includesOverall) {
                setIsOverallAssigned(true);
              }

              const actualUsers = selected.filter(
                (item) => item.value !== "overall-users"
              );

              setAssignedTo(actualUsers.map((item) => String(item.value)));
            }}
            labelledBy="Select Users"
          />

          <h3 className="todo-name">Copy to</h3>
          <MultiSelect
            className="todo-dropdown"
            options={getOptions(isOverallCC)}
            value={ccTo
              .map((id) => {
                const source =
                  isOverallCC || tsCategory === "General"
                    ? users
                    : tsCategory === "Project"
                    ? projectUsers
                    : projectManager || [];

                const user = source.find((u) => String(u.id) === String(id));
                return user
                  ? { label: user.name, value: String(user.id) }
                  : null;
              })
              .filter(Boolean)}
            onChange={(selected) => {
              const includesOverall = selected.some(
                (item) => item.value === "overall-users"
              );

              if (includesOverall) {
                setIsOverallCC(true);
              }

              const actualUsers = selected.filter(
                (item) => item.value !== "overall-users"
              );

              setCCTo(actualUsers.map((item) => String(item.value)));
            }}
            labelledBy="Select Users"
          />

          <h3 className="todo-name">Report to</h3>
          <MultiSelect
            className="todo-dropdown"
            options={
              tsCategory === "Project" || tsCategory === "Estimate"
                ? projectCustomers.map((user) => ({
                    label: user.contact_name || "Unnamed",
                    value: String(user.contact_id), // Ensure value is a string
                  }))
                : users.map((user) => ({
                    label: user.name || "Unnamed",
                    value: String(user.id), // Ensure value is a string
                  }))
            }
            value={reportedTo
              .map((id) => {
                const user =
                  tsCategory === "Project" || tsCategory === "Estimate"
                    ? projectCustomers.find(
                        (u) => String(u.contact_id) === String(id)
                      )
                    : users.find((u) => String(u.id) === String(id));
                return user
                  ? {
                      label:
                        tsCategory === "Project" || tsCategory === "Estimate"
                          ? user.contact_name
                          : user.name,
                      value:
                        tsCategory === "Project" || tsCategory === "Estimate"
                          ? String(user.contact_id)
                          : String(user.id),
                    }
                  : null;
              })
              .filter(Boolean)}
            onChange={(selected) =>
              setReportedTo(selected.map((item) => String(item.value)))
            }
            labelledBy="Select Users"
          />
          <div className="due-priority-con">
            <div>
              <h3 className="todo-name">Due Date</h3>
              <DatePicker
                className="todo-p-input"
                selected={todoDueDate}
                onChange={(date) => setTodoDueDate(date)}
                dateFormat="dd-MM-yyyy"
                required
              />
            </div>
            <div>
              <h3 className="todo-name">Priority</h3>
              <div className="radio-group">
                <input
                  type="radio"
                  name="priority"
                  id="low"
                  value="Low"
                  checked={priority === "Low"}
                  onChange={handlePriorityChange}
                />
                <label htmlFor="low">Low</label>

                <input
                  type="radio"
                  name="priority"
                  id="medium"
                  value="Medium"
                  checked={priority === "Medium"}
                  onChange={handlePriorityChange}
                />
                <label htmlFor="medium">Medium</label>

                <input
                  type="radio"
                  name="priority"
                  id="high"
                  value="High"
                  checked={priority === "High"}
                  onChange={handlePriorityChange}
                />
                <label htmlFor="high">High</label>
              </div>
            </div>
          </div>
          <h3 className="todo-name">Subject</h3>
          <input
            className="input-todo-sub"
            value={subject}
            maxLength={150}
            onChange={(e) => setSubject(e.target.value)}
          />
          <h3 className="todo-name">Add Description</h3>
          <textarea
            className="todo-des"
            value={comments}
            maxLength={200}
            onChange={(e) => setComments(e.target.value)}
            placeholder="Enter comments"
          />
          <div className="email-checkbox-container">
            <input
              type="checkbox"
              id="email"
              style={{ cursor: "pointer" }}
              checked={notification === 1}
              onChange={(e) => setNotification(e.target.checked ? 1 : 0)}
            />
            <label htmlFor="email" style={{ cursor: "pointer" }}>
              Email notification
            </label>
          </div>
        </div>
        <div className="todo-btn-container">
          <button className="add-btn todo-add-btn" onClick={handleAddToDoList}>
            Add
          </button>
          <button
            className="cancel-btn todo-cancel-btn"
            onClick={() => {
              setTsCategory("Project");
              setSelectedEstimate("");
              setAssignedTo([]);
              setCCTo([]);
              setReportedTo([]);
              setComments("");
              setSelectedProject("");
              setSelectedProjectName("");
              setTodoDueDate("");
              setIsOverallAssigned(false);
              setIsOverallCC(false);
              setSubject("");
              setTodoDialOpen(false);
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTodo;
